import i18next from 'i18next';

i18next.addResources('es_CL', 'App', {
  kdsLogo: 'KDS logo Mercat',
  pizza: 'Pizza'
});

i18next.addResources('es_CR', 'App', {
  kdsLogo: 'KDS logo Mercat',
  pizza: 'Pizza'
});
